import { ENV } from 'config';
import posthog from 'posthog-js';

import { AnalyticsConfig, AnalyticsProvider } from './types';

let active = false;

const PostHog: AnalyticsProvider = {
    init: (config: AnalyticsConfig) => {
        if (!ENV.POSTHOG_TOKEN || !config.clarityEnabled) {
            return;
        }

        /* eslint-disable camelcase */
        posthog.init(ENV.POSTHOG_TOKEN, {
            api_host: ENV.POSTHOG_HOST,
            capture_pageview: true,
            autocapture: true,
            disable_session_recording: false,
            capture_exceptions: true,
            persistence: 'localStorage+cookie',
            opt_in_site_apps: true
        });
        /* eslint-enable camelcase */

        if (config.userId) {
            posthog.identify(config.userId, {
                tenant: config.tenant,
                ...config.properties
            });
        }

        posthog.register({
            tenant: config.tenant,
            env: ENV.NODE_ENV
        });

        active = true;
    },
    event: (name: string, data?: Record<string, unknown>) => {
        if (active) {
            posthog.capture(name, data);
        }
    }
};

export default PostHog;
